export function extractFieldDecoratorProps(_ref) {
  var error = _ref.error,
    required = _ref.required,
    readonly = _ref.readonly,
    label = _ref.label,
    labelTooltip = _ref.labelTooltip,
    labelTooltipPlacement = _ref.labelTooltipPlacement,
    labelFor = _ref.labelFor,
    caption = _ref.caption,
    hint = _ref.hint,
    disabled = _ref.disabled,
    showHintIcon = _ref.showHintIcon,
    size = _ref.size,
    validationState = _ref.validationState,
    className = _ref.className;
  return {
    error: error,
    required: required,
    readonly: readonly,
    label: label,
    labelTooltip: labelTooltip,
    labelTooltipPlacement: labelTooltipPlacement,
    labelFor: labelFor,
    caption: caption,
    hint: hint,
    disabled: disabled,
    showHintIcon: showHintIcon,
    size: size,
    validationState: validationState,
    className: className
  };
}